﻿import React from 'react';
import {CardItemValue} from "../CardItemValue";
import {styled} from "@mui/styles";

const Root = styled(CardItemValue)(() => ({
  color: '#FF0000'
}));

type CardItemValueRedProps = React.ComponentPropsWithoutRef<'span'>;

const CardItemValueRed = (props: CardItemValueRedProps) => {
  return <Root {...props} />
};

export { CardItemValueRed };
